import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { ZagButton } from '../button/button';
import { ZagIcon } from '../icon/icon';
import { PopoverDirective, type PopoverPosition } from './popover.directive';

// Slots: [slot=title], default content (text), [slot=footer] (chips)
@Component({
  selector: 'zag-info-popover',
  imports: [PopoverDirective, ZagButton, ZagIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './info-popover.component.scss',
  template: `
    <button
      type="button"
      zagButton="icon"
      zagType="secondary"
      zagSize="sm"
      class="zag-info-popover__trigger"
      [attr.aria-label]="ariaLabel()"
      [zagPopover]="panel"
      [popoverLabel]="ariaLabel()"
      [popoverPosition]="position()"
      [(popoverOpen)]="open"
    >
      <span zagIcon="info" zagOutlined class="zag-info-popover__icon"></span>
    </button>
    <ng-template #panel>
      <div class="zag-info-popover__title"><ng-content select="[slot=title]" /></div>
      <ng-content />
      <div class="zag-info-popover__footer"><ng-content select="[slot=footer]" /></div>
    </ng-template>
  `,
})
export class InfoPopoverComponent {
  readonly ariaLabel = input.required<string>();

  readonly position = input<PopoverPosition>('below');

  readonly open = model(false);
}
